/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { ApprovalsAppFilterContainer as ApprovalsAppFilter } from './ApprovalsAppFilter.container';
